<template>
  <div
    v-show="!adding"
    class="gift-with-purchase critical-component-clear"
  >
    <mini-product-form
      :product="product"
      :title="giftTitle"
      :show-price="false"
      :line-props="{ _isGift: 'true' }"
      :use-product-url="false"
      @add-cart="handleAdded"
      @before-add-cart="adding = true"
      @add-cart-error="adding = false"
    />
  </div>
</template>

<script>
/**
 * Vue: gift-with-purchase (gift-with-purchase)
 * -----------------------------------------------------------------------------
 * Gift with purchase.
 *
 * @param {Object} product - Product object.
 *
 */

import { formatProductTitle } from '~/helpers/format';

import { formatCustomEcommerceItem, track } from '~/helpers/datalayer-actions';
import MiniProductForm from '~async/mini-product-form/mini-product-form';

export default {
  name: 'GiftWithPurchase',

  components: {
    MiniProductForm,
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: {
    'gift-added': () => true,
  },

  data() {
    return {
      adding: false,
    }
  },

  computed: {
    /**
     * Update gift title with product title.
     * @returns {String} - Gift title.
     */
    giftTitle() {
      if (!this.product || !this.product.title) {
        return ''
      }
      return this.$string('cart.free_gift.title_html', {
        replace: {
          product: formatProductTitle(this.product.title),
        },
      })
    },
  },

  methods: {
    /**
     * Handle when successfully added to cart
     * @param payload
     */
    handleAdded(payload) {
      this.$emit('gift-added', payload)
      this.adding = false
      track({
        event: 'gwp_add_to_cart',
        ...formatCustomEcommerceItem(payload),
      })
    },
  },
}
</script>

<style lang="scss">
@import './gift-with-purchase';
</style>
